// internationalization
import { useTranslation } from 'react-i18next';

// shared components
import { getDefaultPresets } from '@/components/ui/datetime/dateRangePresets';

const DAY_PRESET_KEYS = [
  'last_week',
  'last_month',
  'last_90_days',
  'ytd',
  'previous_year',
];

export const useDayRangePresets = () => {
  const { t } = useTranslation('view-data');
  return getDefaultPresets(t).filter((preset) =>
    DAY_PRESET_KEYS.includes(preset.key),
  );
};
